

























import { Component, Vue } from 'vue-property-decorator';
import { Restaurant } from '@/api/model';
import RestaurantForm from '@/components/profile/RestaurantForm.vue';

@Component({ components: { RestaurantForm } })
export default class ProfileRestaurants extends Vue {
  get state() {
    return this.$store.state.restaurant;
  }

  get restaurants(): Restaurant[] {
    return this.state.restaurants;
  }

  created() {
    this.$store.dispatch('restaurant/getRestaurants');
  }

  addRestaurant() {
    const restaurant: Restaurant = {};
    this.$store.commit('restaurant/updateRestaurant', restaurant);
  }

  isActive(restaurantId: string): boolean {
    return this.state.activeRestaurantId === restaurantId;
  }
}
